<template>
    <footer class="foot-bg">
        <div class="foot-content">
            <el-row :gutter="20">
                <el-col :span="6" class="col-div-1">
                    <div class="download-box" @click="$router.push('/help')">
                        <i class="iconfont icon-xiazai"></i><span>下载供应商帮助指南</span>
                    </div>
                </el-col>
                <el-col :span="8" class="col-div-1">
                    <div class="left-icon"><i class="iconfont icon-rili"></i></div>
                    <div class="right-text">
                        <div class="tip-1">问题咨询请加QQ群：882437923</div>
                        <div class="tip-1">工作时间：周一至周五 08:30-17:30</div>
                        <div class="info-item">
                            <i class="iconfont icon-dizhi"></i><span>上海市大渡河路388弄1号（200662）</span>
                        </div>
                        <div class="info-item">
                            <i class="iconfont icon-youxiang"></i><span>zhangyao@dahuahome.com</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6" class="col-div-2">
                    <div class="code-box">
                        <div class="foot-code" v-if="$root.env == 'prod'">
                            <div class="code-one">
                                <p>安卓</p>
                                <img :src="urlDate.androidImgUrl" width="70px" height="70px">
                            </div>
                            <div class="code-one">
                                <p>IOS</p>
                                <img :src="urlDate.iosImgUrl" width="70px" height="70px">
                            </div>
                        </div>

                        <div class="code-text">浏览器扫码下载手机客户端</div>
                    </div>
                </el-col>
                <el-col :span="4" class="col-div-2">
                    <div class="code-box">
                        <img :src="zcImgUrl" width="80px" height="80px" style="margin-top: 40px;">
                        <div class="code-text">成本招采平台公众号</div>
                    </div>
                </el-col>
                
                
            </el-row>
        </div>
        <div class="copyright-div">
            Copyright @2016-2020 大华集团有限公司 All rights reserved 沪ICP备05019979号-1 公网安备31011302003462号
        </div>
    </footer>
</template>

<script type="text/babel">

export default {
    name: 'page-footer',
    data () {
        return {
            urlDate: {
                androidImgUrl: require('../assets/imgs/android_insatll.png'),
                iosImgUrl: require('../assets/imgs/app_install.png')
            },
            zcImgUrl: require('../assets/imgs/zcpt_img.png')
        }
    }
}
</script>

<style lang="css">
.foot-bg{
    width: 100%;
    height: 250px;
    background-image: url("../assets/homeNew/footer_img.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: relative;
}
.foot-bg .foot-content{
    width: 1200px;
    margin: 0 auto;
}
.foot-bg .foot-content .col-div-1{
    overflow: hidden;
    padding-top: 82px;
}
.foot-bg .foot-content .left-icon{
    float: left;
    width: 38px;
    height: 38px;
    border: 1px solid #ffffff;
    border-radius: 50%;
    text-align: center;
    line-height: 38px;
}
.foot-bg .foot-content .left-icon .iconfont{
    font-size: 22px;
    color: #ffffff;
}
.col-div-1 .right-text{
    float: left;
    color: #E3E3E3;
    margin-left: 17px;
}
.col-div-1 .right-text .tip-1{
    font-size: 14px;
    line-height: 20px;
}
.col-div-1 .right-text .tip-2{
    font-size: 18px;
    line-height: 30px;
}
.col-div-1 .info-item{
    color: #E3E3E3;
    font-size: 14px;
    line-height: 22px;
}
.col-div-1 .info-item .iconfont{
    font-size: 14px;
    margin-right: 10px;
}
.col-div-1 .download-box{
    width: 205px;
    height: 42px;
    text-align: center;
    border: 1px solid #e3e3e3;
    border-radius: 21px;
    color: #E3E3E3;
    font-size: 14px;
    line-height: 42px;
    margin: 0 auto;
    cursor: pointer;
}
.col-div-1 .download-box .iconfont{
    font-size: 14px;
    margin-right: 10px;
}
.foot-bg .copyright-div{
    width: 100%;
    border-top: 1px solid #585859;
    height: 47px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #aaaaaa;
    line-height: 47px;
    position: absolute;
    bottom: 0;
}
.col-div-2{
    padding-top: 31px;
}
.col-div-2 .code-box{
    text-align: center;
}
.col-div-2 .code-text{
    color: #E3E3E3;
    font-size: 14px;
    margin-bottom: 12px;
}
.col-div-2 .code-img{
    width: 105px;
    height: 105px;
    margin: 0 auto;
}
.foot-bg .foot-code {
    margin-left: 20%;
}

.foot-code .code-one {
    display: table-cell;
    padding: 0 10px;
}
.foot-code .code-one p {
    color: #E3E3E3;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue